import { render, staticRenderFns } from "./PrintQuestionsInfo.vue?vue&type=template&id=27a820a9&"
import script from "./PrintQuestionsInfo.vue?vue&type=script&lang=js&"
export * from "./PrintQuestionsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports